import { Arrows as r } from "./arrows/index.js";
import { Cities as o } from "./cities/index.js";
import { Countries as m } from "./countries/index.js";
import { Devices24 as t } from "./devices-24/index.js";
import { Extra24 as i } from "./extra-24/index.js";
import { Files as p } from "./files/index.js";
import { Interface as e } from "./interface/index.js";
import { Products24 as f } from "./products-24/index.js";
import { ProductsAndFeatures as s } from "./products-and-features/index.js";
import { Shapes as a } from "./shapes/index.js";
import { TeamIcons as c } from "./team/index.js";
import { Various as n } from "./various/index.js";
const w = {
  Arrows: r,
  Cities: o,
  Countries: m,
  Devices24: t,
  Extra24: i,
  Files: p,
  Interface: e,
  Products24: f,
  ProductsAndFeatures: s,
  Shapes: a,
  Team: c,
  Various: n
};
export {
  w as Icons24
};
